export default __webpack_public_path__ + "static/media/aaa_2024.6582ffb6.png";